// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"0f75cb18","453":"dd0a1086"}[chunkId] + ".chunk.js";
};